import { animated, useSpring } from 'react-spring';

type Props = {};

const XConnectPreloader = (props: Props) => {
  const stylesLogo = useSpring({
    to: { translateY: '0px', opacity: 1 },
    from: { translateY: '100px', opacity: 0 },
    config: {
      duration: 350,
    },
  });

  const stylesLabel = useSpring({
    to: { translateY: '0px', opacity: 1 },
    from: { translateY: '50px', opacity: 0 },
    config: {
      duration: 200,
    },
  });

  return (
    <div className="flex flex-col justify-center items-center w-full h-full fixed block top-0 left-0 z-50 bg-[#fdfdfd]">
      <video className="w-[600px] mt-10" autoPlay src="/assets/video/cip-animation.mp4" muted loop>
        Your browser doesn't support HTML5 video tag.
      </video>
      <div className="mt-auto pb-16">
        <animated.div style={stylesLabel} className="text-center mb-5">
          Powered by
        </animated.div>
        <animated.div className="flex justify-center" style={stylesLogo}>
          <img src="/assets/images/xsight-logo.png" alt="xsight logo" />
        </animated.div>
      </div>
    </div>
  );
};

export default XConnectPreloader;
